<template>
  <v-snackbar v-model="popUpNotification" :timeout="popUpTimeout" bottom multi-line right @input="popUpClose()">
    <v-icon :color="popUpContent.level.toLowerCase()" class="mr-2" large>{{ popUpContent.level.toLowerCase() }}</v-icon>
    {{ $t(popUpContent.content, popUpContent.contentParameters) }}
    <v-btn icon @click="popUpClose()">
      <v-icon color="rgba(255,255,255,0.3)">cancel</v-icon>
    </v-btn>
  </v-snackbar>
</template>
<script>
import {EventBus} from "@/lib/event-bus";
import {EVENTBUS_TOPICS} from "@/lib/constants";

export default {
  name: "notification-popup",
  data() {
    return {
      popUpContent: {title: "Test", titleParameters: [], contentParameters: [], level: "info", isI18n: false},
      popUpNotification: false,
      popUpQueue: [],
      popUpTimeout: 5000,
    };
  },
  methods: {
    popUpClose() {
      this.popUpNotification = false;
      if (this.notificationsInPopUpQueue) {
        this.popUpContent = this.popUpQueue.shift();
        setTimeout(() => {
          this.popUpNotification = true;
        }, 250);
      }
    },
  },
  computed: {
    notificationsInPopUpQueue() {
      return this.popUpQueue.length > 0;
    },
  },
  mounted() {
    EventBus.$on(EVENTBUS_TOPICS.NEW_NOTIFICATION, (notification) => {
      if (this.popUpNotification) {
        this.popUpQueue.push(notification);
      } else {
        this.popUpContent = notification;
        this.popUpNotification = true;
      }
    });
  },
  beforeDestroy() {
    EventBus.$off(EVENTBUS_TOPICS.NEW_NOTIFICATION);
  },
};
</script>
<style scoped>
</style>
